// extracted by mini-css-extract-plugin
export var bottomRightDock = "_2f-0";